// @flow

export const ADDRESS_SECTION_INITIATE = 'ADDRESS_SECTION_INITIATE'
export const ADDRESS_SECTION_EDIT = 'ADDRESS_SECTION_EDIT'
export const ADDRESS_SECTION_CANCEL = 'ADDRESS_SECTION_CANCEL'
export const ADDRESS_SECTION_CHANGE = 'ADDRESS_SECTION_CHANGE'
export const ADDRESS_SECTION_PROMO = 'ADDRESS_SECTION_PROMO'
export const ADDRESS_SECTION_ERROR = 'ADDRESS_SECTION_ERROR'
